import { Box, Button, Fade, Typography, useTheme } from "@mui/material";
import TotalChart from "../TotalChart";
import Filter from "./Filter";
import useChartOrderContainer from "./useChartOrderContainer";
import useDeviceType from "../../../global/Hooks/useDeviceType";
import TitleChart from "../components/TitleChart";
import useCheckDisplayChart from "../components/useCheckDisplayChart";
import { Filter1, Filter2 } from "@mui/icons-material";
import { FilterIcon } from "lucide-react";
import { useState } from "react";
import ChartRenderer from "./ChartRenderer";
import TabChartFilter from "../components/TabChartFilter";
import FilterHandler from "../components/FilterHandler";

function OrderTypeChart() {
  const theme = useTheme().palette.mode;

  const {
    dataLineChart,
    chartFilter,
    activeFilterType,
    changeActiveFilterType,
    total,
    designerFiled,
    setDesignerFiled,
    customerFieldValue,
    setCustomerFieldValue,
    tabHandler,
    year,
    setYear,
    month,
    setMonth,
    day,
    setDay,
  } = useChartOrderContainer();
  const deviceType = useDeviceType();

  /* -------------------------------- Accrdion -------------------------------- */
  const chartKey = "orderTypeChart";
  const { displayChart } = useCheckDisplayChart(chartKey);
  const [filter, setFilter] = useState(false);
  const toPersianDigits = (input) => {
    if (input === null || input === undefined) return "";

    const str = input.toString();

    // normalize Persian digits to English
    const normalized = str.replace(
      /[۰-۹]/g,
      (d) => "0123456789"["۰۱۲۳۴۵۶۷۸۹".indexOf(d)],
    );

    // find number only
    const match = normalized.match(/\d+(?:,\d{3})*(?:\.\d+)?/);
    if (!match) return str;

    const formatted = Number(match[0].replace(/,/g, "")).toLocaleString(
      "en-US",
    );

    const persianFormatted = formatted.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

    // replace ONLY the matched number
    return str.replace(match[0], persianFormatted);
  };
  return (
    <>
      {displayChart ? (
        <Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 2,
              marginBottom: "4px",
              flexWrap: "nowrap",
              overflowX: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "50%",
                padding: "0.5rem",
              }}
            >
              <Button
                onClick={() => changeActiveFilterType(1)}
                sx={{
                  color: theme === "dark" ? "#FFF" : "#262D39",
                  borderBottom:
                    activeFilterType === 1
                      ? "2px solid rgba(30, 106, 253, 1)"
                      : "",
                }}
              >
                نوع سفارش
              </Button>
              <Button
                onClick={() => changeActiveFilterType(2)}
                sx={{
                  color: theme === "dark" ? "#FFF" : "#262D39",
                  borderBottom:
                    activeFilterType === 2
                      ? "2px solid rgba(30, 106, 253, 1)"
                      : "",
                }}
              >
                وضعیت سفارش
              </Button>
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                width: "25%",
                display: "flex",
                justifyContent: "flex-start",
                minWidth: 200,
              }}
            >
              <TitleChart label={"تناسب سفارش"} chartKey={chartKey} />
            </Box>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginLeft: "auto",
                  marginRight: "8px",
                }}
              >
                <TabChartFilter
                  chartFilter={chartFilter}
                  tabHandler={tabHandler}
                  name="Order"
                />
              </Box>
              <Box sx={{ placeSelf: "end" }}>
                <FilterHandler filter={filter} setFilter={setFilter} />
              </Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={{
                display: "block",
                width: "100%",
                padding: "0.5rem",
                justifyContent: "space-between",
                flexDirection: deviceType === "mobile" ? "column" : "row",
              }}
            >
              {filter && (
                <Fade in={filter} timeout={300}>
                  <Box
                    sx={{
                      marginTop: "12px",
                      marginBottom: "8px",
                      padding: "8px",
                      backgroundColor: theme == "light" ? "#E6F1FF" : "#161B25",
                    }}
                  >
                    <Filter
                      customerFieldValue={customerFieldValue}
                      designerFiled={designerFiled}
                      setFieldValue={setCustomerFieldValue}
                      setDesignerFiled={setDesignerFiled}
                      chartFilter={chartFilter}
                      year={year}
                      setYear={setYear}
                      month={month}
                      setMonth={setMonth}
                      day={day}
                      setDay={setDay}
                    />
                  </Box>
                </Fade>
              )}
            </Box>
            <ChartRenderer
              data={dataLineChart}
              totalRecord={total}
              activeFilterType={activeFilterType}
            />

            <Box display={"flex"}>
              <Typography color="#3592FB">
                جمع کل: {total.map((item) => toPersianDigits(item.count))}
              </Typography>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TitleChart label={"تناسب سفارش"} chartKey={chartKey} />
        </Box>
      )}
    </>
  );
}

export default OrderTypeChart;
